export const Notification_Types = {
  INFO: "info",
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  REMINDER: "reminder",
};

export const Notification_Actions = {
  DOWNLOAD: "Download",
  NAVIGATE: "Navigate",
  VIEW: "View",
};
